import { Body } from "@sprout/typography";
import { Stack } from "@sprout/layout.tsx";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@components/ui/dialog";
import { Trans } from "react-i18next";
import { PrimaryButton, SecondaryButton } from "@sprout/buttons";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLeaveWithoutSaving: () => void;
  onSave: () => void;
};

const SaveChangesModal = ({ open, onOpenChange, onLeaveWithoutSaving, onSave }: Props) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md" hideClose={false}>
        <DialogHeader>
          <DialogTitle>
            <Trans i18nKey="user:save_changes_modal:title" />
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <div className="support-modal__body">
            <Stack gap="8px">
              <Body>
                <Trans i18nKey="user:save_changes_modal:description" />
              </Body>
            </Stack>
          </div>
        </DialogDescription>
        <DialogFooter>
          <SecondaryButton onClick={onLeaveWithoutSaving}>
            <Trans i18nKey="user:save_changes_modal:leave" />
          </SecondaryButton>
          <PrimaryButton onClick={onSave}>
            <Trans i18nKey="user:save_changes_modal:save" />
          </PrimaryButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveChangesModal;
